/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import PropTypes from 'prop-types';

import {CloseIcon} from '@salesforce/retail-react-app/app/components/icons';
import {Box, Button, Wrap, WrapItem} from '@salesforce/retail-react-app/app/components/shared/ui';
import {REMOVE_FILTER} from '@salesforce/retail-react-app/app/pages/product-list/partials/refinements-utils';

const SelectedRefinements = ({toggleFilter, selectedFilterValues, filters, handleReset}) => {
  const {formatMessage} = useIntl();
  const priceFilterValues = filters?.find((filter) => filter.attributeId === 'price');

  let selectedFilters = [];

  for (const key in selectedFilterValues) {
    const filters = selectedFilterValues[key].split('|');

    filters?.forEach((filter) => {
      const selected = {
        uiLabel:
          key === 'price' ?
            priceFilterValues?.values?.find(
              (priceFilter) => priceFilter.value === filter
            )?.label :
            filter,
        value: key,
        apiLabel: filter,
      };

      if (selected.value !== 'htype' && selected.value !== 'cgid') {
        selectedFilters.push(selected);
      }
    });
  }

  return (
    <Wrap
      align="center"
      data-testid="sf-selected-refinements"
      direction="row"
      display="flex"
      flexWrap="wrap"
    >
      {selectedFilters?.map((filter, idx) => {
        return (
          <WrapItem key={idx}>
            <Box marginLeft={0} marginRight={1}>
              <Button
                aria-label={formatMessage(REMOVE_FILTER, {label: filter.uiLabel})}
                color="black"
                colorScheme="gray"
                iconSpacing={1}
                marginTop={1}
                padding={5}
                size="sm"
                rightIcon={
                  <CloseIcon boxSize={4} color="black" mb="-6px" mr="-7px" />
                }
                onClick={() => toggleFilter({value: filter.apiLabel}, filter.value, true)}
              >
                {filter.uiLabel}
              </Button>
            </Box>
          </WrapItem>
        );
      })}

      {selectedFilters?.length > 0 && (
        <WrapItem>
          <Box>
            <Button
              padding={{sm: 0, base: 2}}
              size="sm"
              variant="link"
              aria-label={formatMessage({
                id: 'selected_refinements.action.assistive_msg.clear_all',
                defaultMessage: 'Clear all filters',
              })}
              onClick={handleReset}
            >
              <FormattedMessage
                defaultMessage="Clear All"
                id="selected_refinements.action.clear_all"
              />
            </Button>
          </Box>
        </WrapItem>
      )}
    </Wrap>
  );
};

SelectedRefinements.propTypes = {
  filters: PropTypes.array,
  selectedFilterValues: PropTypes.object,
  toggleFilter: PropTypes.func,
  handleReset: PropTypes.func,
};

export default SelectedRefinements;
